import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DrawerService {
  readonly isOpen      = signal(false);
  readonly overlayOpen = signal(false);   // true while any page-level modal is visible

  toggle() { this.isOpen.update(v => !v); }
  close()  { this.isOpen.set(false); }
  open()   { this.isOpen.set(true); }

  showOverlay() { this.overlayOpen.set(true); }
  hideOverlay() { this.overlayOpen.set(false); }
}
